
import {Component, Prop, Vue} from 'vue-property-decorator'
import {apiNewsShopLists} from '@/api/shop'
import LsUpload from '@/components/ls-upload.vue'
import {apiIndustryAdd, apiIndustryDetail, apiIndustryEdit} from '@/api/IndustryRequests'

import {debounce, RequestPaging} from '@/utils/util'
import MaterialSelect from "@/components/material-select/index.vue";

@Component({
  components: {
    MaterialSelect,
    LsUpload
  }
})
export default class ListsDetail extends Vue {
  /** S Data **/
  @Prop({default: 20}) pageSize!: number
  @Prop({default: 'popup'}) mode!: 'pages' | 'popup'
  identity: number | null = null; // 当前编辑用户的身份ID

  currentId = ''
  shopData: any[] = []
  selectList: any[] = []
  pager = new RequestPaging({size: this.pageSize})
  // 添加行业求购表单数据
  form: any = {
    sid: '', // 商城列表
    title: '', // 视频列表(数组形式)
    upload_time: '',
  };

  rules = {
    sid: [{required: true, message: '请选择商城列表', trigger: ['blur', 'change']}],
    title: [{required: true, message: '请输入名称', trigger: ['blur', 'change']}],
    upload_time: [{required: true, message: '请选择上传时间', trigger: ['blur', 'change']}],
  };

  // 点击表单提交
  onSubmit(formName: string) {
    // 验证表单格式是否正确
    const refs = this.$refs[formName] as HTMLFormElement
    refs.validate((valid: boolean): any => {
      if (!valid) return
      this.form.type = 3;
      if (!this.identity) {
        this.handleShopAdd()
      } else {
        this.handleShopEdit()
      }
    })
  }

  // 添加域名输入框
  addDomain() {
    this.form.domain_alias_list.push('')
  }

  // 移除域名输入框
  removeDomain(index: number) {
    if (this.form.domain_alias_list.length > 1) {
      this.form.domain_alias_list.splice(index, 1)
    }
  }

  // 获取详情
  async getShopDetailFunc(): Promise<void> {
    const res: any = await apiIndustryDetail({
      id: this.identity as number
    })

    // 将字符串类型的video_url转换为数组并赋值给video_list
    if (res.video_url) {
      res.video_list = typeof res.video_url === 'string' ?
          res.video_url.split(',').filter(Boolean) : // 处理字符串情况
          [res.video_url].filter(Boolean); // 处理单个值情况
    } else {
      res.video_list = []; // 处理无值情况
    }

    Object.keys(res).map((key) => {
      this.$set(this.form, key, res[key])
    })
  }

  // 添加行业求购
  async handleShopAdd(): Promise<void> {
    // 数组转字符串
    const postData = {
      ...this.form,
    }
    await apiIndustryAdd(postData)
    setTimeout(() => this.$router.go(-1), 500)
  }

  // 编辑行业求购
  async handleShopEdit(): Promise<void> {
    // 数组转字符串
    const postData = {
      ...this.form,
      id: this.identity
    }
    await apiIndustryEdit(postData)
    setTimeout(() => this.$router.go(-1), 500)
  }

  //获取商场列表数据
  async getShopListsFn(): Promise<void> {
    const res: any = await apiNewsShopLists({
      page_no: 1,
      page_size: 100,
    })
    this.shopData = res.data;
  }

  created() {
    const query: any = this.$route.query

    // 编辑模式：初始化数据
    this.identity = +query.id
    if (+query.id) {
      this.getShopDetailFunc()
    }
    // 获取商城列表是数据
    this.getShopListsFn()
    this.onSubmit = debounce(this.onSubmit, 2000)

  }

  /** E Life Cycle **/
}
